export function duplicate(orderState, editOrderState, state) {
  let orderStateNew = { ...orderState };
  let mainstate = { ...editOrderState };
  let activeRecipentIndex = 0;

  //Card Details
  let order_card_list =
    orderStateNew.order_transaction.order_payment_transactions?.map(
      (cardData) => {
        return {
          id: cardData.id ?? 0,
          transaction_id: cardData.transaction_id ?? "",
          transaction_type: cardData.transaction_type ?? "credit_card",
          card_id: cardData.card_id ?? 0,
          card_last_4_digits: cardData.card_last_4_digits ?? "",
          transaction_status: cardData.transaction_status ?? "",
          total_amount: cardData.total_amount ?? 0,
        };
      }
    );

  //Setting Recipients
  let recipents = orderStateNew.order_recipients.map((recipentData) => {
    let added_product = [];
    let addedAddons = [];
    recipentData.order_products.forEach((productdata) => {
      let data = {
        sqlid: productdata.id ?? "",
        order_id: productdata.order_id ?? 0,
        order_recipients_id: productdata.order_recipients_id ?? 0,
        product_id: productdata?.product_id ?? 0,
        id: productdata?.product_id ?? 0,
        product_type: productdata.product_type === false ? 0 : 1,
        qty: productdata.qty ?? 0,
        unit_price: productdata.unit_price ?? 0,
        total_price: productdata.total_price ?? 0,
        promocode: productdata.promocode ?? "",
        discount_price: productdata.discount_price ?? 0,
        commission_price: productdata.commission_price ?? 0,
        total_commission_price: productdata.total_commission_price ?? 0,
        product_name: productdata.product_name ?? "",
        variation_id: productdata.variation_id ?? 0,
        variation_image: productdata.variation_image ?? "",
        variation_name: productdata.variation_name ?? "",
        title: productdata.product_name ?? "",
        selectedVariant: {
          image: productdata.variation_image ?? "",
          price: productdata.unit_price ?? 0,
          commission: productdata.commission_price ?? 0,
          title: productdata.variation_name ?? "",
          id: productdata.variation_id ?? 0,
          productid: productdata.product_id ?? 0,
        },
      };
      if (productdata.product_type === false) {
        added_product.push(data);
      } else {
        addedAddons.push(data);
      }
    });
    return {
      form: {
        recipients_id: recipentData.recipients_id ?? 0,
        id: recipentData.id ?? 0,
        whats_the_occasion: recipentData.whats_the_occasion ?? "",
        whats_the_occasion_id: recipentData.whats_the_occasion_id ?? 0,
        first_name: recipentData.first_name ?? "",
        last_name: recipentData.last_name ?? "",
        greetings_on_card: recipentData.greetings_on_card ?? "",
        card_signature: recipentData.card_signature ?? "",
        video_url: recipentData.video_url ?? "",
        video_message: recipentData.video_message ?? "",
        video_message_pass_code: recipentData.video_message_pass_code ?? "",
        completed: true,
      },
      // isVerifiedRecipient:

      added_product: added_product,
      addedAddons: addedAddons,
      flower_total: orderStateNew.flower_total_amount ?? 0,
      tax: orderStateNew.tax ?? 0,
      delivery_charge: orderStateNew.delivery_charges ?? 0,
      subtotal: orderStateNew.sub_total ?? 0,
      total: orderStateNew.total ?? 0,
      deleted_recipient_product_id: [],
      internal_notes: "",
    };
  });

  //Setting delivery information
  let formInfo = orderStateNew.order_recipients.map((Formdata) => {
    return {
      order_id: Formdata.order_id,
      address_type: Formdata.address_type,
      address_type_id: Formdata.address_type_id,
      attn: Formdata.attn,
      address_line_1: Formdata.address_line_1,
      address_line_2: Formdata.address_line_2,
      phone: Formdata.phone,
      alt_phone: Formdata.alt_phone,
      city: Formdata.city,
      state: Formdata.state,
      zipcode: Formdata.zipcode,
      country: "usa",
      is_local: orderStateNew.is_local_order ?? 0,
      latitude: "",
      longitude: "",
    };
  });

  //Customer Information
  let customer_info = {
    customer_id: orderStateNew.order_transaction.customer_id,
    customer_first_name:
      orderStateNew.order_transaction.customer_first_name ?? "",
    customer_last_name:
      orderStateNew.order_transaction.customer_last_name ?? "",
    customer_billing_address:
      orderStateNew.order_transaction.customer_billing_address ?? "",
    customer_billing_city:
      orderStateNew.order_transaction.customer_billing_city ?? "",
    customer_billing_state:
      orderStateNew.order_transaction.customer_billing_state ?? "",
    customer_billing_country: "usa",
    customer_billing_zipcode:
      orderStateNew.order_transaction.customer_billing_zipcode ?? "",
    customer_email: orderStateNew.order_transaction.customer_email ?? "",
    is_business_account: orderStateNew.order_transaction.is_business_account ?? 0, 
    customer_phone: orderStateNew.order_transaction.customer_phone ?? "",
    customer_alt_phone:
      orderStateNew.order_transaction.customer_alt_phone ?? "",
    is_default: 0,
  };

  let delivery_type_id = orderStateNew.delivery_type_id ?? 0;

  let not_available_at_home_key = orderStateNew.not_available_at_home_key ?? "";

  let not_available_at_home_option =
    orderStateNew.not_available_at_home_option ?? "";

  let is_local_available = orderStateNew.is_local_order ?? false;

  //Setting Billing data
  let billing_data = {
    customer_billing_first_name:
      orderStateNew.order_transaction.customer_billing_first_name ?? "",
    customer_billing_last_name:
      orderStateNew.order_transaction.customer_billing_last_name ?? "",
    customer_billing_address:
      orderStateNew.order_transaction.customer_billing_address_1 ?? "",
    customer_billing_city:
      orderStateNew.order_transaction.customer_billing_city ?? "",
    customer_billing_state:
      orderStateNew.order_transaction.customer_billing_state ?? "",
    customer_billing_country: "United States",
    customer_billing_zipcode:
      orderStateNew.order_transaction.customer_billing_zipcode ?? "",
  };

  return {
    ...mainstate,
    order: {
      ...mainstate.order,
      internal_notes: `${state} order for order number ${orderStateNew.order_number}`,
    },
    editMode: false,
    custom_order: orderStateNew.is_custom_order,
    activeRecipentIndex: activeRecipentIndex,
    billing_data: billing_data,
    formInfo: formInfo[0],
    customer_info: customer_info,
    delivery_type_id: delivery_type_id,
    not_available_at_home_key: not_available_at_home_key,
    not_available_at_home_option: not_available_at_home_option,
    is_local_available: is_local_available,
    recipents: recipents,
    order_type_identifier: 2,
    parent_order_id: orderStateNew.id,
    order_card_list: order_card_list,
    order_number: orderStateNew.order_number,
  };
}
